import React, { Component } from 'react'
import moment from 'moment';
import { connect } from 'react-redux';
import AccountsApi from '../../api/accounts';
import AdministratorApi from '../../api/administrators';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import AllLoans from '../AllLoans';
import MSDPreview from '../AllLoans/MSDPreview';
import MyStudentDataUploader from '../MyStudentDataUploader';
import AnalysisTools from '../../utils/AnalysisTools';
import MSDComparison from './MSDComparison';

class MSDDetails extends Component
{
  constructor()
  {
    super();
    this.state = {
      msdDetails: null,
      marked: false,
      deleting: false
    };
  }
  getMsdDetails = async (msdFile) =>
  {
    try
    {
      const details = await AccountsApi.getMsdDetails(msdFile);
      this.setState({ msdDetails: details });
    } catch (error)
    {
      this.props.showError();
    }
  }
  onClose = () =>
  {
    this.setState({ msdDetails: null })
  }

  onUpload = async (response) =>
  {
    try
    {
      await this.props.getMsds()
      this.props.onMyStudentDataUploaded(response.msd);
      if (response && response.forceAnalysis)
      {
        const analysis = await AccountsApi.runAnalysis(this.props.account._id, true);
        if (analysis.changed && analysis.preApproved)
        {
          this.props.onAnalysisUpdated(analysis);
          this.props.showMessage('The new MyStudentData has modified the approved strategy, a Student Loan coach has been notified to  re-review the strategy. Please take into account that even though you may proceed to complete the sale, the final numbers in the strategy and the strategy itself, might change after a coach review.');
        } else
        {
          if (!analysis.preApproved)
            this.props.onAnalysisUpdated(analysis);
          this.props.showMessage(
            !analysis.preApproved
              ? 'The new MyStudentData has been saved and the the strategy has been updated to take into account the new information.'
              : 'The MyStudentData has been updated, there were no changes in the strategy.'
          );
        }
      } else
      {
        this.props.confirmAction(
          'The new MyStudentData file might impact the strategy found for this user. Would you like to run the analysis again with the new MyStudentData file?',
          async () =>
          {
            const analysis = await AccountsApi.runAnalysis(this.props.account._id, true)
            if (analysis.changed && analysis.preApproved)
            {
              this.props.onAnalysisUpdated(analysis);
              this.props.showMessage(
                'The new MyStudentData has modified the approved strategy, a Student Loan coach has been notified to  re-review the strategy. Please take into account that even though you may proceed to complete the sale, the final numbers in the strategy and the strategy itself, might change after a coach review.'
              );
            } else
            {
              if (!analysis.preApproved)
                this.props.onAnalysisUpdated(analysis);
              this.props.showMessage(
                !analysis.preApproved
                  ? 'The new MyStudentData has been saved and the the strategy has been updated to take into account the new information.'
                  : 'The MyStudentData has been updated, there were no changes in the strategy.'
              );
            }
          },
          'Update Analysis',
          'Run Analysis',
          "Don't Run it"
        );
      }
    } catch (error)
    {
      this.props.showError();
    }
  }

  onDelete = (msdId) =>
  {
    this.props.confirmAction(
      'You are going to permanently delete this MyStudentData file and all the information associated to it. This process is irreversible and all the information will be completely lost. Do you want to proceed and delete the MSD anyway?',
      () =>
        this.props.confirmAction(
          'Please confirm that you want to permanently delete the user\'s MyStudentData file.',
          () =>
            this.setState({ deleting: true }, async () =>
            {
              try
              {
                await AdministratorApi.deleteMSD(this.props.account._id, msdId);
                this.props.showMessage('The MSD file has been deleted.');
                window.location.reload()
              } catch (error)
              {
                this.setState({ deleting: false }, this.props.showError(error))
              }
            }
            ),
          'Please Confirm',
          'Delete MyStudentData file Permanently',
          'Cancel'
        ),
      'Warning!!!'
    )
  }

  render()
  {
    const { msds } = this.props;
    const msdsThatCanBeCompared = (msds || []).filter(msd => msd.details.request_date);
    if (!msds)
    {
      return <p>Loading MSDs</p>
    }
    if (!msds.length && this.props.account.loanType !== 'private')
    {
      return (
        <div className="flex space-between">
          <h3>MyStudentData file history</h3>
          <MyStudentDataUploader
            name="file"
            id={this.props.account._id}
            onUpload={this.onUpload}
            onError={this.props.showError}
            className="btn btn-primary btn-mini loading"
            accept="text/plain"
          >
            Update
          </MyStudentDataUploader>
        </div>
      )
    }
    return (
      <div>
        <br />
        <div className='flex flex-1 w-100'>
          {msdsThatCanBeCompared.length > 1 && <MSDComparison
            msds={msdsThatCanBeCompared}
            onError={this.props.showError}
          />
          }
        </div>
        <h3>MyStudentData file history</h3>
        {
          msds.map((each, index) => (
            <div key={index}>
              <div className="flex space-between">
                <div>
                  User Loan
                  {each.details.request_date && <span>&nbsp; &nbsp; MSD Timestamp {moment(each.details.request_date, "X").format("MM/DD/YYYY")}</span>}
                  {
                    index === 0 && this.state.marked &&
                    <span className="indicator-badge-gray">
                      Peoplejoy marked as recent
                    </span>
                  }
                  {
                    index === 0 && each.uploaded_by &&
                    <span className="indicator-badge-gray">
                      {each.uploaded_by === 'peoplejoy' ? 'PeopleJoy ' : 'User '}
                      last uploaded MSD on{' '}
                      {moment(each.date, 'X').format('MM/DD/YYYY')}
                    </span>
                  }

                  {
                    index === 0 &&
                    AnalysisTools.hasRecertificationPending(this.props.account) &&
                    (!each.date || each.date < AnalysisTools.getRecertificationThreshold()) && (
                      <div className="indicator-badge">update required</div>
                    )
                  }
                </div>
                <div>
                  {
                    index === 0 && this.props.account.loanType !== 'private' &&
                    <MyStudentDataUploader
                      name="file"
                      id={this.props.account._id}
                      onUpload={this.onUpload}
                      onError={this.props.showError}
                      className="btn btn-primary btn-mini loading"
                      accept="text/plain"
                    >
                      Update
                    </MyStudentDataUploader>
                  }
                  &nbsp; &nbsp;
                  {!each.details.isArtificial && <button className="btn btn-secondary btn-mini" onClick={() => this.getMsdDetails(each.file)}>Preview</button>}
                  {!each.details.isArtificial && <button className="btn btn-secondary btn-mini" onClick={() => this.onDelete(each._id)}>Delete</button>}
                </div>
              </div>
              <br />
              <AllLoans
                onLoanUpdated={this.props.onLoanUpdated}
                onAnalysisUpdated={this.props.onAnalysisUpdated}
                account={this.props.account}
                msdId={each._id}
                myStudentData={each.details}
                canEdit={index === 0}
              />
              <br /><br />
              {this.state.msdDetails &&
                <MSDPreview
                  preview={this.state.msdDetails && true}
                  onClose={this.onClose}
                  msdDetails={this.state.msdDetails}
                />
              }
            </div>
          ))
        }
      </div>
    )
  }
}

export default connect(null, {
  showError,
  showMessage,
  confirmAction
})(MSDDetails);